/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const Subscribe = $root.Subscribe = (() => {

    /**
     * Properties of a Subscribe.
     * @exports ISubscribe
     * @interface ISubscribe
     * @property {Array.<string>|null} [docIDs] Subscribe docIDs
     */

    /**
     * Constructs a new Subscribe.
     * @exports Subscribe
     * @classdesc Represents a Subscribe.
     * @implements ISubscribe
     * @constructor
     * @param {ISubscribe=} [properties] Properties to set
     */
    function Subscribe(properties) {
        this.docIDs = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Subscribe docIDs.
     * @member {Array.<string>} docIDs
     * @memberof Subscribe
     * @instance
     */
    Subscribe.prototype.docIDs = $util.emptyArray;

    /**
     * Creates a new Subscribe instance using the specified properties.
     * @function create
     * @memberof Subscribe
     * @static
     * @param {ISubscribe=} [properties] Properties to set
     * @returns {Subscribe} Subscribe instance
     */
    Subscribe.create = function create(properties) {
        return new Subscribe(properties);
    };

    /**
     * Encodes the specified Subscribe message. Does not implicitly {@link Subscribe.verify|verify} messages.
     * @function encode
     * @memberof Subscribe
     * @static
     * @param {ISubscribe} message Subscribe message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Subscribe.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.docIDs != null && message.docIDs.length)
            for (let i = 0; i < message.docIDs.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.docIDs[i]);
        return writer;
    };

    /**
     * Encodes the specified Subscribe message, length delimited. Does not implicitly {@link Subscribe.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Subscribe
     * @static
     * @param {ISubscribe} message Subscribe message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Subscribe.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Subscribe message from the specified reader or buffer.
     * @function decode
     * @memberof Subscribe
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Subscribe} Subscribe
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Subscribe.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Subscribe();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.docIDs && message.docIDs.length))
                    message.docIDs = [];
                message.docIDs.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Subscribe message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Subscribe
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Subscribe} Subscribe
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Subscribe.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Subscribe message.
     * @function verify
     * @memberof Subscribe
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Subscribe.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.docIDs != null && message.hasOwnProperty("docIDs")) {
            if (!Array.isArray(message.docIDs))
                return "docIDs: array expected";
            for (let i = 0; i < message.docIDs.length; ++i)
                if (!$util.isString(message.docIDs[i]))
                    return "docIDs: string[] expected";
        }
        return null;
    };

    /**
     * Creates a Subscribe message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Subscribe
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Subscribe} Subscribe
     */
    Subscribe.fromObject = function fromObject(object) {
        if (object instanceof $root.Subscribe)
            return object;
        let message = new $root.Subscribe();
        if (object.docIDs) {
            if (!Array.isArray(object.docIDs))
                throw TypeError(".Subscribe.docIDs: array expected");
            message.docIDs = [];
            for (let i = 0; i < object.docIDs.length; ++i)
                message.docIDs[i] = String(object.docIDs[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a Subscribe message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Subscribe
     * @static
     * @param {Subscribe} message Subscribe
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Subscribe.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.docIDs = [];
        if (message.docIDs && message.docIDs.length) {
            object.docIDs = [];
            for (let j = 0; j < message.docIDs.length; ++j)
                object.docIDs[j] = message.docIDs[j];
        }
        return object;
    };

    /**
     * Converts this Subscribe to JSON.
     * @function toJSON
     * @memberof Subscribe
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Subscribe.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Subscribe;
})();

export const Unsubscribe = $root.Unsubscribe = (() => {

    /**
     * Properties of an Unsubscribe.
     * @exports IUnsubscribe
     * @interface IUnsubscribe
     * @property {string} docID Unsubscribe docID
     */

    /**
     * Constructs a new Unsubscribe.
     * @exports Unsubscribe
     * @classdesc Represents an Unsubscribe.
     * @implements IUnsubscribe
     * @constructor
     * @param {IUnsubscribe=} [properties] Properties to set
     */
    function Unsubscribe(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Unsubscribe docID.
     * @member {string} docID
     * @memberof Unsubscribe
     * @instance
     */
    Unsubscribe.prototype.docID = "";

    /**
     * Creates a new Unsubscribe instance using the specified properties.
     * @function create
     * @memberof Unsubscribe
     * @static
     * @param {IUnsubscribe=} [properties] Properties to set
     * @returns {Unsubscribe} Unsubscribe instance
     */
    Unsubscribe.create = function create(properties) {
        return new Unsubscribe(properties);
    };

    /**
     * Encodes the specified Unsubscribe message. Does not implicitly {@link Unsubscribe.verify|verify} messages.
     * @function encode
     * @memberof Unsubscribe
     * @static
     * @param {IUnsubscribe} message Unsubscribe message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Unsubscribe.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.docID);
        return writer;
    };

    /**
     * Encodes the specified Unsubscribe message, length delimited. Does not implicitly {@link Unsubscribe.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Unsubscribe
     * @static
     * @param {IUnsubscribe} message Unsubscribe message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Unsubscribe.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Unsubscribe message from the specified reader or buffer.
     * @function decode
     * @memberof Unsubscribe
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Unsubscribe} Unsubscribe
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Unsubscribe.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Unsubscribe();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.docID = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("docID"))
            throw $util.ProtocolError("missing required 'docID'", { instance: message });
        return message;
    };

    /**
     * Decodes an Unsubscribe message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Unsubscribe
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Unsubscribe} Unsubscribe
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Unsubscribe.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Unsubscribe message.
     * @function verify
     * @memberof Unsubscribe
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Unsubscribe.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.docID))
            return "docID: string expected";
        return null;
    };

    /**
     * Creates an Unsubscribe message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Unsubscribe
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Unsubscribe} Unsubscribe
     */
    Unsubscribe.fromObject = function fromObject(object) {
        if (object instanceof $root.Unsubscribe)
            return object;
        let message = new $root.Unsubscribe();
        if (object.docID != null)
            message.docID = String(object.docID);
        return message;
    };

    /**
     * Creates a plain object from an Unsubscribe message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Unsubscribe
     * @static
     * @param {Unsubscribe} message Unsubscribe
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Unsubscribe.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.docID = "";
        if (message.docID != null && message.hasOwnProperty("docID"))
            object.docID = message.docID;
        return object;
    };

    /**
     * Converts this Unsubscribe to JSON.
     * @function toJSON
     * @memberof Unsubscribe
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Unsubscribe.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Unsubscribe;
})();

export const Welcome = $root.Welcome = (() => {

    /**
     * Properties of a Welcome.
     * @exports IWelcome
     * @interface IWelcome
     * @property {string} docID Welcome docID
     * @property {Uint8Array|null} [savedState] Welcome savedState
     * @property {Array.<Uint8Array>|null} [updates] Welcome updates
     * @property {Array.<number>|null} [updateTypes] Welcome updateTypes
     */

    /**
     * Constructs a new Welcome.
     * @exports Welcome
     * @classdesc Represents a Welcome.
     * @implements IWelcome
     * @constructor
     * @param {IWelcome=} [properties] Properties to set
     */
    function Welcome(properties) {
        this.updates = [];
        this.updateTypes = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Welcome docID.
     * @member {string} docID
     * @memberof Welcome
     * @instance
     */
    Welcome.prototype.docID = "";

    /**
     * Welcome savedState.
     * @member {Uint8Array} savedState
     * @memberof Welcome
     * @instance
     */
    Welcome.prototype.savedState = $util.newBuffer([]);

    /**
     * Welcome updates.
     * @member {Array.<Uint8Array>} updates
     * @memberof Welcome
     * @instance
     */
    Welcome.prototype.updates = $util.emptyArray;

    /**
     * Welcome updateTypes.
     * @member {Array.<number>} updateTypes
     * @memberof Welcome
     * @instance
     */
    Welcome.prototype.updateTypes = $util.emptyArray;

    /**
     * Creates a new Welcome instance using the specified properties.
     * @function create
     * @memberof Welcome
     * @static
     * @param {IWelcome=} [properties] Properties to set
     * @returns {Welcome} Welcome instance
     */
    Welcome.create = function create(properties) {
        return new Welcome(properties);
    };

    /**
     * Encodes the specified Welcome message. Does not implicitly {@link Welcome.verify|verify} messages.
     * @function encode
     * @memberof Welcome
     * @static
     * @param {IWelcome} message Welcome message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Welcome.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.docID);
        if (message.savedState != null && Object.hasOwnProperty.call(message, "savedState"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.savedState);
        if (message.updates != null && message.updates.length)
            for (let i = 0; i < message.updates.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.updates[i]);
        if (message.updateTypes != null && message.updateTypes.length) {
            writer.uint32(/* id 4, wireType 2 =*/34).fork();
            for (let i = 0; i < message.updateTypes.length; ++i)
                writer.uint32(message.updateTypes[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified Welcome message, length delimited. Does not implicitly {@link Welcome.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Welcome
     * @static
     * @param {IWelcome} message Welcome message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Welcome.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Welcome message from the specified reader or buffer.
     * @function decode
     * @memberof Welcome
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Welcome} Welcome
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Welcome.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Welcome();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.docID = reader.string();
                break;
            case 2:
                message.savedState = reader.bytes();
                break;
            case 3:
                if (!(message.updates && message.updates.length))
                    message.updates = [];
                message.updates.push(reader.bytes());
                break;
            case 4:
                if (!(message.updateTypes && message.updateTypes.length))
                    message.updateTypes = [];
                if ((tag & 7) === 2) {
                    let end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.updateTypes.push(reader.uint32());
                } else
                    message.updateTypes.push(reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("docID"))
            throw $util.ProtocolError("missing required 'docID'", { instance: message });
        return message;
    };

    /**
     * Decodes a Welcome message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Welcome
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Welcome} Welcome
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Welcome.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Welcome message.
     * @function verify
     * @memberof Welcome
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Welcome.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.docID))
            return "docID: string expected";
        if (message.savedState != null && message.hasOwnProperty("savedState"))
            if (!(message.savedState && typeof message.savedState.length === "number" || $util.isString(message.savedState)))
                return "savedState: buffer expected";
        if (message.updates != null && message.hasOwnProperty("updates")) {
            if (!Array.isArray(message.updates))
                return "updates: array expected";
            for (let i = 0; i < message.updates.length; ++i)
                if (!(message.updates[i] && typeof message.updates[i].length === "number" || $util.isString(message.updates[i])))
                    return "updates: buffer[] expected";
        }
        if (message.updateTypes != null && message.hasOwnProperty("updateTypes")) {
            if (!Array.isArray(message.updateTypes))
                return "updateTypes: array expected";
            for (let i = 0; i < message.updateTypes.length; ++i)
                if (!$util.isInteger(message.updateTypes[i]))
                    return "updateTypes: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a Welcome message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Welcome
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Welcome} Welcome
     */
    Welcome.fromObject = function fromObject(object) {
        if (object instanceof $root.Welcome)
            return object;
        let message = new $root.Welcome();
        if (object.docID != null)
            message.docID = String(object.docID);
        if (object.savedState != null)
            if (typeof object.savedState === "string")
                $util.base64.decode(object.savedState, message.savedState = $util.newBuffer($util.base64.length(object.savedState)), 0);
            else if (object.savedState.length)
                message.savedState = object.savedState;
        if (object.updates) {
            if (!Array.isArray(object.updates))
                throw TypeError(".Welcome.updates: array expected");
            message.updates = [];
            for (let i = 0; i < object.updates.length; ++i)
                if (typeof object.updates[i] === "string")
                    $util.base64.decode(object.updates[i], message.updates[i] = $util.newBuffer($util.base64.length(object.updates[i])), 0);
                else if (object.updates[i].length)
                    message.updates[i] = object.updates[i];
        }
        if (object.updateTypes) {
            if (!Array.isArray(object.updateTypes))
                throw TypeError(".Welcome.updateTypes: array expected");
            message.updateTypes = [];
            for (let i = 0; i < object.updateTypes.length; ++i)
                message.updateTypes[i] = object.updateTypes[i] >>> 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a Welcome message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Welcome
     * @static
     * @param {Welcome} message Welcome
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Welcome.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.updates = [];
            object.updateTypes = [];
        }
        if (options.defaults) {
            object.docID = "";
            if (options.bytes === String)
                object.savedState = "";
            else {
                object.savedState = [];
                if (options.bytes !== Array)
                    object.savedState = $util.newBuffer(object.savedState);
            }
        }
        if (message.docID != null && message.hasOwnProperty("docID"))
            object.docID = message.docID;
        if (message.savedState != null && message.hasOwnProperty("savedState"))
            object.savedState = options.bytes === String ? $util.base64.encode(message.savedState, 0, message.savedState.length) : options.bytes === Array ? Array.prototype.slice.call(message.savedState) : message.savedState;
        if (message.updates && message.updates.length) {
            object.updates = [];
            for (let j = 0; j < message.updates.length; ++j)
                object.updates[j] = options.bytes === String ? $util.base64.encode(message.updates[j], 0, message.updates[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.updates[j]) : message.updates[j];
        }
        if (message.updateTypes && message.updateTypes.length) {
            object.updateTypes = [];
            for (let j = 0; j < message.updateTypes.length; ++j)
                object.updateTypes[j] = message.updateTypes[j];
        }
        return object;
    };

    /**
     * Converts this Welcome to JSON.
     * @function toJSON
     * @memberof Welcome
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Welcome.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Welcome;
})();

export const SubscribeDenied = $root.SubscribeDenied = (() => {

    /**
     * Properties of a SubscribeDenied.
     * @exports ISubscribeDenied
     * @interface ISubscribeDenied
     * @property {string} docID SubscribeDenied docID
     */

    /**
     * Constructs a new SubscribeDenied.
     * @exports SubscribeDenied
     * @classdesc Represents a SubscribeDenied.
     * @implements ISubscribeDenied
     * @constructor
     * @param {ISubscribeDenied=} [properties] Properties to set
     */
    function SubscribeDenied(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SubscribeDenied docID.
     * @member {string} docID
     * @memberof SubscribeDenied
     * @instance
     */
    SubscribeDenied.prototype.docID = "";

    /**
     * Creates a new SubscribeDenied instance using the specified properties.
     * @function create
     * @memberof SubscribeDenied
     * @static
     * @param {ISubscribeDenied=} [properties] Properties to set
     * @returns {SubscribeDenied} SubscribeDenied instance
     */
    SubscribeDenied.create = function create(properties) {
        return new SubscribeDenied(properties);
    };

    /**
     * Encodes the specified SubscribeDenied message. Does not implicitly {@link SubscribeDenied.verify|verify} messages.
     * @function encode
     * @memberof SubscribeDenied
     * @static
     * @param {ISubscribeDenied} message SubscribeDenied message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeDenied.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.docID);
        return writer;
    };

    /**
     * Encodes the specified SubscribeDenied message, length delimited. Does not implicitly {@link SubscribeDenied.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SubscribeDenied
     * @static
     * @param {ISubscribeDenied} message SubscribeDenied message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SubscribeDenied.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SubscribeDenied message from the specified reader or buffer.
     * @function decode
     * @memberof SubscribeDenied
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SubscribeDenied} SubscribeDenied
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeDenied.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SubscribeDenied();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.docID = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("docID"))
            throw $util.ProtocolError("missing required 'docID'", { instance: message });
        return message;
    };

    /**
     * Decodes a SubscribeDenied message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SubscribeDenied
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SubscribeDenied} SubscribeDenied
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SubscribeDenied.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SubscribeDenied message.
     * @function verify
     * @memberof SubscribeDenied
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SubscribeDenied.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.docID))
            return "docID: string expected";
        return null;
    };

    /**
     * Creates a SubscribeDenied message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SubscribeDenied
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SubscribeDenied} SubscribeDenied
     */
    SubscribeDenied.fromObject = function fromObject(object) {
        if (object instanceof $root.SubscribeDenied)
            return object;
        let message = new $root.SubscribeDenied();
        if (object.docID != null)
            message.docID = String(object.docID);
        return message;
    };

    /**
     * Creates a plain object from a SubscribeDenied message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SubscribeDenied
     * @static
     * @param {SubscribeDenied} message SubscribeDenied
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SubscribeDenied.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.docID = "";
        if (message.docID != null && message.hasOwnProperty("docID"))
            object.docID = message.docID;
        return object;
    };

    /**
     * Converts this SubscribeDenied to JSON.
     * @function toJSON
     * @memberof SubscribeDenied
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SubscribeDenied.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SubscribeDenied;
})();

export const Send = $root.Send = (() => {

    /**
     * Properties of a Send.
     * @exports ISend
     * @interface ISend
     * @property {string} docID Send docID
     * @property {Uint8Array} update Send update
     * @property {number} updateType UpdateType enum.
     * @property {number} localCounter Send localCounter
     */

    /**
     * Constructs a new Send.
     * @exports Send
     * @classdesc Represents a Send.
     * @implements ISend
     * @constructor
     * @param {ISend=} [properties] Properties to set
     */
    function Send(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Send docID.
     * @member {string} docID
     * @memberof Send
     * @instance
     */
    Send.prototype.docID = "";

    /**
     * Send update.
     * @member {Uint8Array} update
     * @memberof Send
     * @instance
     */
    Send.prototype.update = $util.newBuffer([]);

    /**
     * UpdateType enum.
     * @member {number} updateType
     * @memberof Send
     * @instance
     */
    Send.prototype.updateType = 0;

    /**
     * Send localCounter.
     * @member {number} localCounter
     * @memberof Send
     * @instance
     */
    Send.prototype.localCounter = 0;

    /**
     * Creates a new Send instance using the specified properties.
     * @function create
     * @memberof Send
     * @static
     * @param {ISend=} [properties] Properties to set
     * @returns {Send} Send instance
     */
    Send.create = function create(properties) {
        return new Send(properties);
    };

    /**
     * Encodes the specified Send message. Does not implicitly {@link Send.verify|verify} messages.
     * @function encode
     * @memberof Send
     * @static
     * @param {ISend} message Send message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Send.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.docID);
        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.update);
        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.updateType);
        writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.localCounter);
        return writer;
    };

    /**
     * Encodes the specified Send message, length delimited. Does not implicitly {@link Send.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Send
     * @static
     * @param {ISend} message Send message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Send.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Send message from the specified reader or buffer.
     * @function decode
     * @memberof Send
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Send} Send
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Send.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Send();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.docID = reader.string();
                break;
            case 2:
                message.update = reader.bytes();
                break;
            case 3:
                message.updateType = reader.uint32();
                break;
            case 4:
                message.localCounter = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("docID"))
            throw $util.ProtocolError("missing required 'docID'", { instance: message });
        if (!message.hasOwnProperty("update"))
            throw $util.ProtocolError("missing required 'update'", { instance: message });
        if (!message.hasOwnProperty("updateType"))
            throw $util.ProtocolError("missing required 'updateType'", { instance: message });
        if (!message.hasOwnProperty("localCounter"))
            throw $util.ProtocolError("missing required 'localCounter'", { instance: message });
        return message;
    };

    /**
     * Decodes a Send message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Send
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Send} Send
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Send.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Send message.
     * @function verify
     * @memberof Send
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Send.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.docID))
            return "docID: string expected";
        if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
            return "update: buffer expected";
        if (!$util.isInteger(message.updateType))
            return "updateType: integer expected";
        if (!$util.isInteger(message.localCounter))
            return "localCounter: integer expected";
        return null;
    };

    /**
     * Creates a Send message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Send
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Send} Send
     */
    Send.fromObject = function fromObject(object) {
        if (object instanceof $root.Send)
            return object;
        let message = new $root.Send();
        if (object.docID != null)
            message.docID = String(object.docID);
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length)
                message.update = object.update;
        if (object.updateType != null)
            message.updateType = object.updateType >>> 0;
        if (object.localCounter != null)
            message.localCounter = object.localCounter >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Send message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Send
     * @static
     * @param {Send} message Send
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Send.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.docID = "";
            if (options.bytes === String)
                object.update = "";
            else {
                object.update = [];
                if (options.bytes !== Array)
                    object.update = $util.newBuffer(object.update);
            }
            object.updateType = 0;
            object.localCounter = 0;
        }
        if (message.docID != null && message.hasOwnProperty("docID"))
            object.docID = message.docID;
        if (message.update != null && message.hasOwnProperty("update"))
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
        if (message.updateType != null && message.hasOwnProperty("updateType"))
            object.updateType = message.updateType;
        if (message.localCounter != null && message.hasOwnProperty("localCounter"))
            object.localCounter = message.localCounter;
        return object;
    };

    /**
     * Converts this Send to JSON.
     * @function toJSON
     * @memberof Send
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Send.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Send;
})();

export const Receive = $root.Receive = (() => {

    /**
     * Properties of a Receive.
     * @exports IReceive
     * @interface IReceive
     * @property {string} docID Receive docID
     * @property {Uint8Array} update Receive update
     * @property {number} updateType UpdateType enum.
     */

    /**
     * Constructs a new Receive.
     * @exports Receive
     * @classdesc Represents a Receive.
     * @implements IReceive
     * @constructor
     * @param {IReceive=} [properties] Properties to set
     */
    function Receive(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Receive docID.
     * @member {string} docID
     * @memberof Receive
     * @instance
     */
    Receive.prototype.docID = "";

    /**
     * Receive update.
     * @member {Uint8Array} update
     * @memberof Receive
     * @instance
     */
    Receive.prototype.update = $util.newBuffer([]);

    /**
     * UpdateType enum.
     * @member {number} updateType
     * @memberof Receive
     * @instance
     */
    Receive.prototype.updateType = 0;

    /**
     * Creates a new Receive instance using the specified properties.
     * @function create
     * @memberof Receive
     * @static
     * @param {IReceive=} [properties] Properties to set
     * @returns {Receive} Receive instance
     */
    Receive.create = function create(properties) {
        return new Receive(properties);
    };

    /**
     * Encodes the specified Receive message. Does not implicitly {@link Receive.verify|verify} messages.
     * @function encode
     * @memberof Receive
     * @static
     * @param {IReceive} message Receive message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Receive.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.docID);
        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.update);
        writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.updateType);
        return writer;
    };

    /**
     * Encodes the specified Receive message, length delimited. Does not implicitly {@link Receive.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Receive
     * @static
     * @param {IReceive} message Receive message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Receive.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Receive message from the specified reader or buffer.
     * @function decode
     * @memberof Receive
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Receive} Receive
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Receive.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Receive();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.docID = reader.string();
                break;
            case 2:
                message.update = reader.bytes();
                break;
            case 3:
                message.updateType = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("docID"))
            throw $util.ProtocolError("missing required 'docID'", { instance: message });
        if (!message.hasOwnProperty("update"))
            throw $util.ProtocolError("missing required 'update'", { instance: message });
        if (!message.hasOwnProperty("updateType"))
            throw $util.ProtocolError("missing required 'updateType'", { instance: message });
        return message;
    };

    /**
     * Decodes a Receive message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Receive
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Receive} Receive
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Receive.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Receive message.
     * @function verify
     * @memberof Receive
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Receive.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.docID))
            return "docID: string expected";
        if (!(message.update && typeof message.update.length === "number" || $util.isString(message.update)))
            return "update: buffer expected";
        if (!$util.isInteger(message.updateType))
            return "updateType: integer expected";
        return null;
    };

    /**
     * Creates a Receive message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Receive
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Receive} Receive
     */
    Receive.fromObject = function fromObject(object) {
        if (object instanceof $root.Receive)
            return object;
        let message = new $root.Receive();
        if (object.docID != null)
            message.docID = String(object.docID);
        if (object.update != null)
            if (typeof object.update === "string")
                $util.base64.decode(object.update, message.update = $util.newBuffer($util.base64.length(object.update)), 0);
            else if (object.update.length)
                message.update = object.update;
        if (object.updateType != null)
            message.updateType = object.updateType >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a Receive message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Receive
     * @static
     * @param {Receive} message Receive
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Receive.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.docID = "";
            if (options.bytes === String)
                object.update = "";
            else {
                object.update = [];
                if (options.bytes !== Array)
                    object.update = $util.newBuffer(object.update);
            }
            object.updateType = 0;
        }
        if (message.docID != null && message.hasOwnProperty("docID"))
            object.docID = message.docID;
        if (message.update != null && message.hasOwnProperty("update"))
            object.update = options.bytes === String ? $util.base64.encode(message.update, 0, message.update.length) : options.bytes === Array ? Array.prototype.slice.call(message.update) : message.update;
        if (message.updateType != null && message.hasOwnProperty("updateType"))
            object.updateType = message.updateType;
        return object;
    };

    /**
     * Converts this Receive to JSON.
     * @function toJSON
     * @memberof Receive
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Receive.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Receive;
})();

export const Ack = $root.Ack = (() => {

    /**
     * Properties of an Ack.
     * @exports IAck
     * @interface IAck
     * @property {string} docID Ack docID
     * @property {number} localCounter Ack localCounter
     * @property {string|null} [checkpointRequest] Ack checkpointRequest
     */

    /**
     * Constructs a new Ack.
     * @exports Ack
     * @classdesc Represents an Ack.
     * @implements IAck
     * @constructor
     * @param {IAck=} [properties] Properties to set
     */
    function Ack(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Ack docID.
     * @member {string} docID
     * @memberof Ack
     * @instance
     */
    Ack.prototype.docID = "";

    /**
     * Ack localCounter.
     * @member {number} localCounter
     * @memberof Ack
     * @instance
     */
    Ack.prototype.localCounter = 0;

    /**
     * Ack checkpointRequest.
     * @member {string} checkpointRequest
     * @memberof Ack
     * @instance
     */
    Ack.prototype.checkpointRequest = "";

    /**
     * Creates a new Ack instance using the specified properties.
     * @function create
     * @memberof Ack
     * @static
     * @param {IAck=} [properties] Properties to set
     * @returns {Ack} Ack instance
     */
    Ack.create = function create(properties) {
        return new Ack(properties);
    };

    /**
     * Encodes the specified Ack message. Does not implicitly {@link Ack.verify|verify} messages.
     * @function encode
     * @memberof Ack
     * @static
     * @param {IAck} message Ack message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Ack.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.docID);
        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.localCounter);
        if (message.checkpointRequest != null && Object.hasOwnProperty.call(message, "checkpointRequest"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.checkpointRequest);
        return writer;
    };

    /**
     * Encodes the specified Ack message, length delimited. Does not implicitly {@link Ack.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Ack
     * @static
     * @param {IAck} message Ack message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Ack.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Ack message from the specified reader or buffer.
     * @function decode
     * @memberof Ack
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Ack} Ack
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Ack.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.Ack();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.docID = reader.string();
                break;
            case 2:
                message.localCounter = reader.uint32();
                break;
            case 3:
                message.checkpointRequest = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("docID"))
            throw $util.ProtocolError("missing required 'docID'", { instance: message });
        if (!message.hasOwnProperty("localCounter"))
            throw $util.ProtocolError("missing required 'localCounter'", { instance: message });
        return message;
    };

    /**
     * Decodes an Ack message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Ack
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Ack} Ack
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Ack.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Ack message.
     * @function verify
     * @memberof Ack
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Ack.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.docID))
            return "docID: string expected";
        if (!$util.isInteger(message.localCounter))
            return "localCounter: integer expected";
        if (message.checkpointRequest != null && message.hasOwnProperty("checkpointRequest"))
            if (!$util.isString(message.checkpointRequest))
                return "checkpointRequest: string expected";
        return null;
    };

    /**
     * Creates an Ack message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Ack
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Ack} Ack
     */
    Ack.fromObject = function fromObject(object) {
        if (object instanceof $root.Ack)
            return object;
        let message = new $root.Ack();
        if (object.docID != null)
            message.docID = String(object.docID);
        if (object.localCounter != null)
            message.localCounter = object.localCounter >>> 0;
        if (object.checkpointRequest != null)
            message.checkpointRequest = String(object.checkpointRequest);
        return message;
    };

    /**
     * Creates a plain object from an Ack message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Ack
     * @static
     * @param {Ack} message Ack
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Ack.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.docID = "";
            object.localCounter = 0;
            object.checkpointRequest = "";
        }
        if (message.docID != null && message.hasOwnProperty("docID"))
            object.docID = message.docID;
        if (message.localCounter != null && message.hasOwnProperty("localCounter"))
            object.localCounter = message.localCounter;
        if (message.checkpointRequest != null && message.hasOwnProperty("checkpointRequest"))
            object.checkpointRequest = message.checkpointRequest;
        return object;
    };

    /**
     * Converts this Ack to JSON.
     * @function toJSON
     * @memberof Ack
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Ack.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Ack;
})();

export const CheckpointResponse = $root.CheckpointResponse = (() => {

    /**
     * Properties of a CheckpointResponse.
     * @exports ICheckpointResponse
     * @interface ICheckpointResponse
     * @property {string} docID CheckpointResponse docID
     * @property {Uint8Array} savedState CheckpointResponse savedState
     * @property {string} checkpointRequest CheckpointResponse checkpointRequest
     */

    /**
     * Constructs a new CheckpointResponse.
     * @exports CheckpointResponse
     * @classdesc Represents a CheckpointResponse.
     * @implements ICheckpointResponse
     * @constructor
     * @param {ICheckpointResponse=} [properties] Properties to set
     */
    function CheckpointResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckpointResponse docID.
     * @member {string} docID
     * @memberof CheckpointResponse
     * @instance
     */
    CheckpointResponse.prototype.docID = "";

    /**
     * CheckpointResponse savedState.
     * @member {Uint8Array} savedState
     * @memberof CheckpointResponse
     * @instance
     */
    CheckpointResponse.prototype.savedState = $util.newBuffer([]);

    /**
     * CheckpointResponse checkpointRequest.
     * @member {string} checkpointRequest
     * @memberof CheckpointResponse
     * @instance
     */
    CheckpointResponse.prototype.checkpointRequest = "";

    /**
     * Creates a new CheckpointResponse instance using the specified properties.
     * @function create
     * @memberof CheckpointResponse
     * @static
     * @param {ICheckpointResponse=} [properties] Properties to set
     * @returns {CheckpointResponse} CheckpointResponse instance
     */
    CheckpointResponse.create = function create(properties) {
        return new CheckpointResponse(properties);
    };

    /**
     * Encodes the specified CheckpointResponse message. Does not implicitly {@link CheckpointResponse.verify|verify} messages.
     * @function encode
     * @memberof CheckpointResponse
     * @static
     * @param {ICheckpointResponse} message CheckpointResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckpointResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.docID);
        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.savedState);
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.checkpointRequest);
        return writer;
    };

    /**
     * Encodes the specified CheckpointResponse message, length delimited. Does not implicitly {@link CheckpointResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckpointResponse
     * @static
     * @param {ICheckpointResponse} message CheckpointResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckpointResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckpointResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CheckpointResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckpointResponse} CheckpointResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckpointResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckpointResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.docID = reader.string();
                break;
            case 2:
                message.savedState = reader.bytes();
                break;
            case 3:
                message.checkpointRequest = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("docID"))
            throw $util.ProtocolError("missing required 'docID'", { instance: message });
        if (!message.hasOwnProperty("savedState"))
            throw $util.ProtocolError("missing required 'savedState'", { instance: message });
        if (!message.hasOwnProperty("checkpointRequest"))
            throw $util.ProtocolError("missing required 'checkpointRequest'", { instance: message });
        return message;
    };

    /**
     * Decodes a CheckpointResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckpointResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckpointResponse} CheckpointResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckpointResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckpointResponse message.
     * @function verify
     * @memberof CheckpointResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckpointResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.docID))
            return "docID: string expected";
        if (!(message.savedState && typeof message.savedState.length === "number" || $util.isString(message.savedState)))
            return "savedState: buffer expected";
        if (!$util.isString(message.checkpointRequest))
            return "checkpointRequest: string expected";
        return null;
    };

    /**
     * Creates a CheckpointResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckpointResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckpointResponse} CheckpointResponse
     */
    CheckpointResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckpointResponse)
            return object;
        let message = new $root.CheckpointResponse();
        if (object.docID != null)
            message.docID = String(object.docID);
        if (object.savedState != null)
            if (typeof object.savedState === "string")
                $util.base64.decode(object.savedState, message.savedState = $util.newBuffer($util.base64.length(object.savedState)), 0);
            else if (object.savedState.length)
                message.savedState = object.savedState;
        if (object.checkpointRequest != null)
            message.checkpointRequest = String(object.checkpointRequest);
        return message;
    };

    /**
     * Creates a plain object from a CheckpointResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckpointResponse
     * @static
     * @param {CheckpointResponse} message CheckpointResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckpointResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.docID = "";
            if (options.bytes === String)
                object.savedState = "";
            else {
                object.savedState = [];
                if (options.bytes !== Array)
                    object.savedState = $util.newBuffer(object.savedState);
            }
            object.checkpointRequest = "";
        }
        if (message.docID != null && message.hasOwnProperty("docID"))
            object.docID = message.docID;
        if (message.savedState != null && message.hasOwnProperty("savedState"))
            object.savedState = options.bytes === String ? $util.base64.encode(message.savedState, 0, message.savedState.length) : options.bytes === Array ? Array.prototype.slice.call(message.savedState) : message.savedState;
        if (message.checkpointRequest != null && message.hasOwnProperty("checkpointRequest"))
            object.checkpointRequest = message.checkpointRequest;
        return object;
    };

    /**
     * Converts this CheckpointResponse to JSON.
     * @function toJSON
     * @memberof CheckpointResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckpointResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CheckpointResponse;
})();

export const WSMessage = $root.WSMessage = (() => {

    /**
     * Properties of a WSMessage.
     * @exports IWSMessage
     * @interface IWSMessage
     * @property {ISubscribe|null} [subscribe] WSMessage subscribe
     * @property {IUnsubscribe|null} [unsubscribe] WSMessage unsubscribe
     * @property {IWelcome|null} [welcome] WSMessage welcome
     * @property {ISubscribeDenied|null} [subscribeDenied] WSMessage subscribeDenied
     * @property {ISend|null} [send] WSMessage send
     * @property {IReceive|null} [receive] WSMessage receive
     * @property {IAck|null} [ack] WSMessage ack
     * @property {ICheckpointResponse|null} [checkpointResponse] WSMessage checkpointResponse
     */

    /**
     * Constructs a new WSMessage.
     * @exports WSMessage
     * @classdesc Represents a WSMessage.
     * @implements IWSMessage
     * @constructor
     * @param {IWSMessage=} [properties] Properties to set
     */
    function WSMessage(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WSMessage subscribe.
     * @member {ISubscribe|null|undefined} subscribe
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.subscribe = null;

    /**
     * WSMessage unsubscribe.
     * @member {IUnsubscribe|null|undefined} unsubscribe
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.unsubscribe = null;

    /**
     * WSMessage welcome.
     * @member {IWelcome|null|undefined} welcome
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.welcome = null;

    /**
     * WSMessage subscribeDenied.
     * @member {ISubscribeDenied|null|undefined} subscribeDenied
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.subscribeDenied = null;

    /**
     * WSMessage send.
     * @member {ISend|null|undefined} send
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.send = null;

    /**
     * WSMessage receive.
     * @member {IReceive|null|undefined} receive
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.receive = null;

    /**
     * WSMessage ack.
     * @member {IAck|null|undefined} ack
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.ack = null;

    /**
     * WSMessage checkpointResponse.
     * @member {ICheckpointResponse|null|undefined} checkpointResponse
     * @memberof WSMessage
     * @instance
     */
    WSMessage.prototype.checkpointResponse = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * WSMessage type.
     * @member {"subscribe"|"unsubscribe"|"welcome"|"subscribeDenied"|"send"|"receive"|"ack"|"checkpointResponse"|undefined} type
     * @memberof WSMessage
     * @instance
     */
    Object.defineProperty(WSMessage.prototype, "type", {
        get: $util.oneOfGetter($oneOfFields = ["subscribe", "unsubscribe", "welcome", "subscribeDenied", "send", "receive", "ack", "checkpointResponse"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new WSMessage instance using the specified properties.
     * @function create
     * @memberof WSMessage
     * @static
     * @param {IWSMessage=} [properties] Properties to set
     * @returns {WSMessage} WSMessage instance
     */
    WSMessage.create = function create(properties) {
        return new WSMessage(properties);
    };

    /**
     * Encodes the specified WSMessage message. Does not implicitly {@link WSMessage.verify|verify} messages.
     * @function encode
     * @memberof WSMessage
     * @static
     * @param {IWSMessage} message WSMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WSMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.subscribe != null && Object.hasOwnProperty.call(message, "subscribe"))
            $root.Subscribe.encode(message.subscribe, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.unsubscribe != null && Object.hasOwnProperty.call(message, "unsubscribe"))
            $root.Unsubscribe.encode(message.unsubscribe, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.welcome != null && Object.hasOwnProperty.call(message, "welcome"))
            $root.Welcome.encode(message.welcome, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.subscribeDenied != null && Object.hasOwnProperty.call(message, "subscribeDenied"))
            $root.SubscribeDenied.encode(message.subscribeDenied, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.send != null && Object.hasOwnProperty.call(message, "send"))
            $root.Send.encode(message.send, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.receive != null && Object.hasOwnProperty.call(message, "receive"))
            $root.Receive.encode(message.receive, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.ack != null && Object.hasOwnProperty.call(message, "ack"))
            $root.Ack.encode(message.ack, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.checkpointResponse != null && Object.hasOwnProperty.call(message, "checkpointResponse"))
            $root.CheckpointResponse.encode(message.checkpointResponse, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified WSMessage message, length delimited. Does not implicitly {@link WSMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WSMessage
     * @static
     * @param {IWSMessage} message WSMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WSMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WSMessage message from the specified reader or buffer.
     * @function decode
     * @memberof WSMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WSMessage} WSMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WSMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WSMessage();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.subscribe = $root.Subscribe.decode(reader, reader.uint32());
                break;
            case 2:
                message.unsubscribe = $root.Unsubscribe.decode(reader, reader.uint32());
                break;
            case 3:
                message.welcome = $root.Welcome.decode(reader, reader.uint32());
                break;
            case 4:
                message.subscribeDenied = $root.SubscribeDenied.decode(reader, reader.uint32());
                break;
            case 5:
                message.send = $root.Send.decode(reader, reader.uint32());
                break;
            case 6:
                message.receive = $root.Receive.decode(reader, reader.uint32());
                break;
            case 7:
                message.ack = $root.Ack.decode(reader, reader.uint32());
                break;
            case 8:
                message.checkpointResponse = $root.CheckpointResponse.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WSMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WSMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WSMessage} WSMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WSMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WSMessage message.
     * @function verify
     * @memberof WSMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WSMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.subscribe != null && message.hasOwnProperty("subscribe")) {
            properties.type = 1;
            {
                let error = $root.Subscribe.verify(message.subscribe);
                if (error)
                    return "subscribe." + error;
            }
        }
        if (message.unsubscribe != null && message.hasOwnProperty("unsubscribe")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = $root.Unsubscribe.verify(message.unsubscribe);
                if (error)
                    return "unsubscribe." + error;
            }
        }
        if (message.welcome != null && message.hasOwnProperty("welcome")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = $root.Welcome.verify(message.welcome);
                if (error)
                    return "welcome." + error;
            }
        }
        if (message.subscribeDenied != null && message.hasOwnProperty("subscribeDenied")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = $root.SubscribeDenied.verify(message.subscribeDenied);
                if (error)
                    return "subscribeDenied." + error;
            }
        }
        if (message.send != null && message.hasOwnProperty("send")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = $root.Send.verify(message.send);
                if (error)
                    return "send." + error;
            }
        }
        if (message.receive != null && message.hasOwnProperty("receive")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = $root.Receive.verify(message.receive);
                if (error)
                    return "receive." + error;
            }
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = $root.Ack.verify(message.ack);
                if (error)
                    return "ack." + error;
            }
        }
        if (message.checkpointResponse != null && message.hasOwnProperty("checkpointResponse")) {
            if (properties.type === 1)
                return "type: multiple values";
            properties.type = 1;
            {
                let error = $root.CheckpointResponse.verify(message.checkpointResponse);
                if (error)
                    return "checkpointResponse." + error;
            }
        }
        return null;
    };

    /**
     * Creates a WSMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WSMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WSMessage} WSMessage
     */
    WSMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.WSMessage)
            return object;
        let message = new $root.WSMessage();
        if (object.subscribe != null) {
            if (typeof object.subscribe !== "object")
                throw TypeError(".WSMessage.subscribe: object expected");
            message.subscribe = $root.Subscribe.fromObject(object.subscribe);
        }
        if (object.unsubscribe != null) {
            if (typeof object.unsubscribe !== "object")
                throw TypeError(".WSMessage.unsubscribe: object expected");
            message.unsubscribe = $root.Unsubscribe.fromObject(object.unsubscribe);
        }
        if (object.welcome != null) {
            if (typeof object.welcome !== "object")
                throw TypeError(".WSMessage.welcome: object expected");
            message.welcome = $root.Welcome.fromObject(object.welcome);
        }
        if (object.subscribeDenied != null) {
            if (typeof object.subscribeDenied !== "object")
                throw TypeError(".WSMessage.subscribeDenied: object expected");
            message.subscribeDenied = $root.SubscribeDenied.fromObject(object.subscribeDenied);
        }
        if (object.send != null) {
            if (typeof object.send !== "object")
                throw TypeError(".WSMessage.send: object expected");
            message.send = $root.Send.fromObject(object.send);
        }
        if (object.receive != null) {
            if (typeof object.receive !== "object")
                throw TypeError(".WSMessage.receive: object expected");
            message.receive = $root.Receive.fromObject(object.receive);
        }
        if (object.ack != null) {
            if (typeof object.ack !== "object")
                throw TypeError(".WSMessage.ack: object expected");
            message.ack = $root.Ack.fromObject(object.ack);
        }
        if (object.checkpointResponse != null) {
            if (typeof object.checkpointResponse !== "object")
                throw TypeError(".WSMessage.checkpointResponse: object expected");
            message.checkpointResponse = $root.CheckpointResponse.fromObject(object.checkpointResponse);
        }
        return message;
    };

    /**
     * Creates a plain object from a WSMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WSMessage
     * @static
     * @param {WSMessage} message WSMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WSMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (message.subscribe != null && message.hasOwnProperty("subscribe")) {
            object.subscribe = $root.Subscribe.toObject(message.subscribe, options);
            if (options.oneofs)
                object.type = "subscribe";
        }
        if (message.unsubscribe != null && message.hasOwnProperty("unsubscribe")) {
            object.unsubscribe = $root.Unsubscribe.toObject(message.unsubscribe, options);
            if (options.oneofs)
                object.type = "unsubscribe";
        }
        if (message.welcome != null && message.hasOwnProperty("welcome")) {
            object.welcome = $root.Welcome.toObject(message.welcome, options);
            if (options.oneofs)
                object.type = "welcome";
        }
        if (message.subscribeDenied != null && message.hasOwnProperty("subscribeDenied")) {
            object.subscribeDenied = $root.SubscribeDenied.toObject(message.subscribeDenied, options);
            if (options.oneofs)
                object.type = "subscribeDenied";
        }
        if (message.send != null && message.hasOwnProperty("send")) {
            object.send = $root.Send.toObject(message.send, options);
            if (options.oneofs)
                object.type = "send";
        }
        if (message.receive != null && message.hasOwnProperty("receive")) {
            object.receive = $root.Receive.toObject(message.receive, options);
            if (options.oneofs)
                object.type = "receive";
        }
        if (message.ack != null && message.hasOwnProperty("ack")) {
            object.ack = $root.Ack.toObject(message.ack, options);
            if (options.oneofs)
                object.type = "ack";
        }
        if (message.checkpointResponse != null && message.hasOwnProperty("checkpointResponse")) {
            object.checkpointResponse = $root.CheckpointResponse.toObject(message.checkpointResponse, options);
            if (options.oneofs)
                object.type = "checkpointResponse";
        }
        return object;
    };

    /**
     * Converts this WSMessage to JSON.
     * @function toJSON
     * @memberof WSMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WSMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WSMessage;
})();

export { $root as default };
